import { useCallback, useEffect } from 'react';

export const useActionOnStart = (action: () => void) => {
    useEffect(() => {
        action();
    }, [action]);

    const restart = useCallback(() => {
        action();
    }, [action]);

    return { restart };
};
